module.exports = "<div class=\"card\" [ngClass]=\"class\">\r\n  <div class=\"card-body\">\r\n    <div *ngIf=\"meta\" class=\"metatitle\">{{meta}}: </div>\r\n    <h5 *ngIf=\"title\"> {{title}}</h5>\r\n    <hr *ngIf=\"divider\" />\r\n    <ng-content></ng-content>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/spk/layouts/spk-card/spk-card.component.html
// module id = ./src/app/components/framework/spk/layouts/spk-card/spk-card.component.html
// module chunks = main